import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Section } from "@/pages/app/brain/BrainSections";
import { Plus, X, Loader2 } from "lucide-react";

const REASON = { la_conozco: "La conoces", manual: "Añadida por ti", sugerencia: "Añadida por ti" };

// v26b · Cuentas de las que CaptAcción no coge audiencia ni propone como lead (amistades, tu equipo, tu compañía…).
export default function VetoedAccounts({ businessType }) {
  const [items, setItems] = useState(null);
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/vetoed-accounts").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e?.preventDefault?.();
    if (!value.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/vetoed-accounts", { account: value, reason: "manual" });
      setValue("");
      toast.success(`No usaremos @${r.data.username}.`);
      load();
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };
  const remove = async (u) => {
    try {
      await api.delete(`/vetoed-accounts/${encodeURIComponent(u)}`);
      setItems((cur) => (cur || []).filter((x) => x.username !== u));
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <Section letter="G" title="Cuentas que no quieres usar" kind="prospeccion" testId="brain-block-vetoed"
      desc="Personas o cuentas que conoces (amistades, tu equipo, tu compañía…). No te las propondremos y no buscaremos entre sus seguidores.">
      {businessType === "network" && (
        <p className="rounded-md border border-brand-accent/40 bg-brand-accent/[0.08] p-3 text-xs text-brand-ink" data-testid="vetoed-network-hint">
          Consejo: añade las cuentas de tu línea ascendente y de tu equipo. Así no buscamos entre su gente.
        </p>
      )}
      <div className="flex gap-2">
        <input value={value} onChange={(e) => setValue(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") add(e); }}
          placeholder="@usuario o enlace a su perfil" className="ca-input flex-1" data-testid="vetoed-input" />
        <button type="button" onClick={add} disabled={busy || !value.trim()} data-testid="vetoed-add"
          className="inline-flex items-center gap-1.5 rounded-md bg-brand-accent px-3 py-2 text-xs font-bold text-brand-canvas hover:brightness-110 disabled:opacity-60">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <Plus size={13} />} Añadir
        </button>
      </div>
      {items && items.length === 0 && <p className="text-xs text-brand-muted" data-testid="vetoed-empty">Aún no has añadido ninguna.</p>}
      {items && items.length > 0 && (
        <ul className="flex flex-wrap gap-2" data-testid="vetoed-list">
          {items.map((x) => (
            <li key={x.username} className="inline-flex items-center gap-1.5 rounded-full border border-brand-line bg-brand-panel2 px-3 py-1 text-xs text-brand-ink">
              @{x.username}<span className="text-brand-muted">· {REASON[x.reason] || "Añadida por ti"}</span>
              <button type="button" onClick={() => remove(x.username)} aria-label={`Quitar @${x.username}`} data-testid={`vetoed-remove-${x.username}`} className="text-brand-muted hover:text-brand-neg"><X size={12} /></button>
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
}
